var identity = identity || {};

identity.pdfUtils = {
    settings: function() {
        return {
            pdfmakeVersion: '0.1.62',

            pageSize: 535,
            pageMargins: [
                30,
                20,
                30,
                80,
            ],
            save: false,
            features: {
                colsPerRow: 3,
                iconSize: 40,
            },
            certificates: {
                colsPerRow: 3,
                iconSize: 40,
            },
            packs: {
                colsPerRow: 5,
            },
            defaultFont: 'OpenSans',
        };
    },
    load: function( fnCallback ) {
        //Load vendor-scripts for pdf-generator - nested as the pdfMake.js needs to load first
        e4.require.js( e4.settings.ecom.pdfmakeUrl, function() {
            e4.require.js( e4.settings.ecom.vfsfontsUrl, function() {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback();
                }
            } );
        } );
    },
    translations: {
        _data: [],
        _pending: false,
        _queue: [],
        get: async () => {
            
            if ( identity.pdfUtils.translations._pending === false && identity.pdfUtils.translations._data.length > 0 ) {
                return identity.pdfUtils.translations._data;
            }
            
            if ( identity.pdfUtils.translations._pending ) {
                return new Promise( ( resolve, reject ) => {
                    identity.pdfUtils.translations._queue.push( { resolve, reject } );
                } );
            }

            identity.pdfUtils.translations._pending = true;

            try {
                const designFolderName = document.body.dataset.design;
                const culture = document.body.dataset.culture;
                const response = await fetch( `/dwapi/translations/${ designFolderName }/${ culture }` );
                if ( !response.ok ) {
                    throw new Error( 'Network response was not ok' );
                }
                const data = await response.json();
                identity.pdfUtils.translations._data = [...data];
                while ( identity.pdfUtils.translations._queue.length > 0 ) {
                    const { resolve } = identity.pdfUtils.translations._queue.shift();
                    resolve( data );
                }
                return data;
            } catch ( error ) {
                while ( identity.pdfUtils.translations._queue.length > 0 ) {
                    const { reject } = identity.pdfUtils.translations._queue.shift();
                    reject( error );
                }
                throw error;
            } finally {
                identity.pdfUtils.translations._pending = false;
            }
        },
        getValues: async ( keys ) => {
            const translations = await identity.pdfUtils.translations.get();
            let returnValue = {};
            Object.keys( keys ).forEach( ( key ) => {
                const translation = translations.find( t => t.Key === keys[key] );
                if(translation){
                    returnValue[key] = translation.Value !== '' ? translation.Value : translation.DefaultValue;
                } else{
                    returnValue[key] = keys[key];
                    console.warn(`-- Translation with key "${keys[key]}" is missing --`)
                }
                
            } );
            return returnValue;
        },
    },
    model: {
        get: function( key, model ) {
            if ( key.indexOf( '.' ) === -1 ) {
                return model[key];
            } else if ( key.indexOf( '.' ) > -1 ) {
                var objSource = model,
                    arrProperties = key.split( '.' ),
                    objReturnValue;
                for ( var i = 0; i < arrProperties.length; i++ ) {
                    var strCurrentPropertyName = arrProperties[i],
                        strRemainingPropertyPathAsPropertyName = arrProperties.slice( i ).join( '.' );
                    if ( objSource.hasOwnProperty( strRemainingPropertyPathAsPropertyName ) === true ) {
                        objReturnValue = objSource[strRemainingPropertyPathAsPropertyName];
                        break;
                    } else {
                        if ( objSource.hasOwnProperty( strCurrentPropertyName ) === true ) {
                            objSource = objSource[strCurrentPropertyName];
                        } else {
                            objReturnValue = undefined;
                            break;
                        }
                    }
                }
                return objReturnValue;
            }
        },
        set: function( key, value, model ) {
            if ( key.indexOf( '.' ) === -1 ) {
                model[key] = value;
            } else if ( key.indexOf( '.' ) > -1 ) {
                var arrProperties = key.split( '.' );
                return arrProperties.reduce( function( objPropertyPath, strCurrentPropertyName, intPropertyPathDepth ) {
                    if ( intPropertyPathDepth === arrProperties.length - 1 ) {

                        objPropertyPath[strCurrentPropertyName] = value;
                    } else {
                        if ( objPropertyPath.hasOwnProperty( strCurrentPropertyName ) === false ) {

                            objPropertyPath[strCurrentPropertyName] = {};
                        }
                    }
                    return objPropertyPath[strCurrentPropertyName];
                }, model );
            }
        },
    },
    image: {
        getDataUri: function( strUrl, fnCallback ) {
            var image = new Image();
            image.onload = function() {
                var canvas = document.createElement( 'canvas' );
                canvas.width = this.naturalWidth;
                canvas.height = this.naturalHeight;
                canvas.getContext( '2d' ).drawImage( this, 0, 0 );
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( canvas.toDataURL( 'image/png' ) );
                }
            };
            image.onerror = function( err ) {
                console.error( err );
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( identity.pdfUtils.image.fallback() );
                }

            };
            image.src = strUrl;
        },
        handler: function( image, size ) {
            if ( image.indexOf( '.svg' ) > -1 ) {
                return image;
            }
            return '/admin/public/getimage.ashx?crop=0&image={image}&Height={height}&Width={width}'.replace( '{image}', image )
                .replace( '{width}', size.width )
                .replace( '{height}', size.height );
        },
        fallback: function() {
            return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        }
    },
    fillArray: function( value, length ) {
        if ( length === 0 ) {
            return [];
        }
        var a = [value];
        while ( a.length * 2 <= length ) {
            a = a.concat( a );
        }
        if ( a.length < length ) {
            a = a.concat( a.slice( 0, length - a.length ) );
        }
        return a;
    },
    getSvgAndTrim: function( svgPath ) {
        return jQuery.ajax( {
            url: svgPath,
        } );
    },
    cleanTableLayout: function( paddingLeft = 0, paddingRight = 0 ) {
        return {
            hLineWidth: function() {
                return 0;
            },
            vLineWidth: function() {
                return 0;
            },
            paddingLeft: function() {
                return paddingLeft;
            },
            paddingRight: function() {
                return paddingRight;
            },
        };
    },
    loader: function( boolLoad ) {
        if ( boolLoad === true ) {
            jQuery( '.js-e-page-loading-overlay' ).addClass( 'is-loading' );
        } else {
            jQuery( '.js-e-page-loading-overlay' ).removeClass( 'is-loading' );
        }
    },
    setFont: function() {
        return {
            OpenSans: {
                normal: 'OpenSans-Regular.ttf',
                bold: 'OpenSans-Bold.ttf',
                italics: 'OpenSans-Italic.ttf',
                bolditalics: 'OpenSans-BoldItalic.ttf',
            },
        };
    },
    measureText: async function( text, opts = {} ) {
        let options = Object.assign( {
            fontSize: 12,
        }, opts );

        const canvas = document.createElement( 'canvas' );
        const ctx = canvas.getContext( '2d' );
        ctx.font = `${ options.fontSize }px Arial`;
        return ctx.measureText( text ).width;
    },
    resizeText: async function( text, currentFontSize, targetWidth = 0 ) {
        if ( targetWidth === 0 ) {
            return currentFontSize;
        }
        currentFontSize -= 1;
        const titleWidth = await identity.pdfUtils.measureText( identity.productDataPdf.model.get( 'name' ), {
            fontSize: currentFontSize,
        } );
        if ( titleWidth <= targetWidth ) {
            return currentFontSize;
        }
        return await identity.pdfUtils.resizeText( text, currentFontSize, targetWidth );
    },

    build: {
        cornerBracket: function( placement = 'bottom', objPosition = { x: 0, y: 0 }, arrMargin = [0, 0, 0, 0] ) {
            var svgMarkup = placement === 'bottom' ?
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path transform="translate(0, -2)" style="fill:none;stroke:#db052a;stroke-width:1px" d="M19,19H7.3C2.35,19,1,17.6,1,12.7V1"/></svg>' :
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path style="fill:none;stroke:#db1f2c;stroke-width:1px" d="M1,19V7.3C1,2.4,2.35,1,7.3,1H19"/></svg>';
            return {
                svg: svgMarkup,
                fit: [14, 14],
                relativePosition: objPosition,
                margin: arrMargin,
            };
        },
        image: function( strImageUri, intWidth, arrMargin, strAlignment, strFillColor ) {
            var image = {
                image: strImageUri,
                width: intWidth,
                margin: arrMargin,
                fillColor: strFillColor,
                alignment: strAlignment,
            };

            if ( intWidth === 0 ) {
                delete image.width;
            }

            return image;
        },
        svg: function( strSvg, intWidth, margin = [0, 0, 0, 0], alignment = 'left' ) {
            return {
                svg: strSvg,
                width: intWidth,
                margin: margin,
                alignment: alignment,
            };
        },
        line: function() {
            return {
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 0,
                        x2: identity.productDataPdf.settings.pageSize,
                        y2: 0,
                        lineWidth: 1,
                        color: '#888',
                    }],
            };
        },
        footer: function() {
            var userStack = '';
            if ( identity.productDataPdf.model.get( 'user.hasUser' ) === true ) {
                userStack = {
                    width: (identity.productDataPdf.settings.pageSize - 60) / 2,
                    stack: [
                        { text: identity.productDataPdf.model.get( 'user.name' ), style: 'small' },
                        { text: identity.productDataPdf.model.get( 'user.address' ), style: 'small' },
                        {
                            text: identity.productDataPdf.model.get( 'user.zip' ) + ' - ' + identity.productDataPdf.model.get( 'user.city' ),
                            style: 'small',
                        },
                        { text: identity.productDataPdf.model.get( 'user.country' ), style: 'small' },
                        { text: identity.productDataPdf.model.get( 'user.email' ), style: 'small' },
                    ],
                    fontSize: 6,
                };
            }
            return {
                margin: [
                    30,
                    0,
                    30,
                    0],
                columns: [
                    {
                        width: (identity.productDataPdf.settings.pageSize - 60) / 2,
                        text: identity.productDataPdf.model.get( 'url' ),
                        fontSize: 8,
                    },
                    {
                        columns: [
                            identity.pdfUtils.build.image( identity.productDataPdf.model.get( 'user.image' ), 50, [0, 0, 0, 0], 'right' ),
                            userStack,
                        ],
                        columnGap: 10,
                        alignment: 'right',
                    },
                ],

            };
        },
    },
    styles: {
        default: function() {
            return {
                productName: {
                    fontSize: 22,
                    bold: true,
                    alignment: 'left',
                },
                date: {
                    fontSize: 10,
                    color: '#1f1f1f',
                    bold: false,
                    alignment: 'center',
                },
                productNumber: {
                    fontSize: 20,
                },
                disclaimerText: {
                    fontSize: 8,
                    alignment: 'left',
                },
                header: {
                    fontSize: 12,
                    bold: true,
                },
                tableHeaderLeft: {
                    fontSize: 9,
                    alignment: 'left',
                    bold: true,
                    fillColor: '#fff',
                },
                tableHeaderRight: {
                    fontSize: 9,
                    alignment: 'right',
                    bold: true,
                    fillColor: '#fff',
                },
                spec: {
                    fontSize: 9,
                },
                specBold: {
                    fontSize: 9,
                    bold: true,
                },
                copy: {
                    fontSize: 9,
                    margin: [
                        0,
                        15,
                        0,
                        15,
                    ],
                },
                small: {
                    fontSize: 9,
                },
                tableHeader: {
                    bold: true,
                    fontSize: 10,
                    color: 'black',
                    alignment: 'center',
                },
            };
        },
    },
};
